module.exports = __webpack_public_path__ + "static/media/icon_tablecharts.c4a21465.svg";